/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Primary_Document_Contact_InvalidInputs */

const en_api_error_primary_document_contact_invalid = /** @type {(inputs: Api_Error_Primary_Document_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The primary document contact must be an enabled Customer for this client.`)
};

const pt_br2_api_error_primary_document_contact_invalid = /** @type {(inputs: Api_Error_Primary_Document_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O contato principal de documentos deve ser um usuário Cliente ativo e autorizado para este cliente.`)
};

/**
* | output |
* | --- |
* | "The primary document contact must be an enabled Customer for this client." |
*
* @param {Api_Error_Primary_Document_Contact_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_primary_document_contact_invalid = /** @type {((inputs?: Api_Error_Primary_Document_Contact_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Primary_Document_Contact_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_primary_document_contact_invalid(inputs)
	return pt_br2_api_error_primary_document_contact_invalid(inputs)
});